import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { cn } from '#cn';
type InputProps = ComponentProps<'input'> & {
  inputSize?: 'sm' | 'md';
};
const inputSizeClasses = {
  sm: 'min-h-8 px-2 py-1.5 text-2xs',
  md: 'min-h-9 px-3 py-2 text-sm shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]'
} as const;

/** A styled text input; `inputSize` picks between `sm`/`md` (default) padding and type scale. */
function Input(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      inputSize: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = type;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    type = $[4];
  }
  const inputSize = t1 === undefined ? "md" : t1;
  const t2 = inputSizeClasses[inputSize];
  let t3;
  if ($[5] !== className || $[6] !== t2) {
    t3 = cn("w-full rounded-lg border border-border bg-surface text-fg outline-none transition-colors", "placeholder:text-fg-subtle", "focus-visible:ring-2 focus-visible:ring-jaaq-black", "aria-invalid:border-danger", "disabled:cursor-not-allowed disabled:opacity-50", t2, className);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t3 || $[10] !== type) {
    t4 = <input type={type} data-slot="input" className={t3} {...props} />;
    $[8] = props;
    $[9] = t3;
    $[10] = type;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export { Input };